var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.setGroceryListFormState.apply(null, arguments)}}},[_c('svg',{staticClass:"icon icon-plus"},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('span',[_vm._v("Spara i din inköpslista")])])
}
var staticRenderFns = []

export { render, staticRenderFns }